import { FC, useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const noSpinnerStyle: React.CSSProperties = {
  MozAppearance: "textfield",
};

interface Props {
  flex: number;
  defaultValue: number;
  onCommit: (value: number) => void;
}

const CurrencyInput: FC<Props> = ({ flex, defaultValue, onCommit }) => {
  const [raw, setRaw] = useState(defaultValue ? String(defaultValue) : "");
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (!editing) {
      setRaw(defaultValue ? String(defaultValue) : "");
    }
  }, [defaultValue]);

  const parsed = parseFloat(raw);
  const safeValue = isNaN(parsed) ? 0 : parsed;
  const formatted = !editing && raw !== "" ? `$${safeValue.toFixed(2)}` : raw;

  const commit = () => {
    setEditing(false);
    setRaw(safeValue ? String(safeValue) : "");
    onCommit(safeValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      (e.target as HTMLInputElement).blur();
    }
  };

  return (
    <div style={{ flex }}>
      <Form.Control
        type="text"
        inputMode="decimal"
        className="no-spinner"
        style={noSpinnerStyle}
        placeholder="$0.00"
        value={formatted}
        onFocus={() => setEditing(true)}
        onChange={(e) => setRaw(e.target.value)}
        onBlur={commit}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default CurrencyInput;
